import React, { FC } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import Helmet from 'react-helmet';
import AccountLayout from '../../components/account-layout';
import EnergyConsultation from '../../components/energy-consultation';

const EnergyConsultationPage: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('ENERGY_CONSULTATION')}</title>
      </Helmet>

      <AccountLayout>
        <EnergyConsultation />
      </AccountLayout>
    </>
  );
};

export default EnergyConsultationPage;
